import { isLocalhost } from '../modules/utilities';

const COMMUNITY_LIST_URL = '/api/location/CommunityList';
const COMMUNITIES_NEAR_YOU_URL = location.hostname === 'localhost' ? '/assets/data/communities.json?' : '/maa-api/nearby/v1/list?'; // TODO update url

export const getCommunityList = async (locationId, templateId, body = {}) => {
  if (isLocalhost()) {
    return testData;
  }
  return fetch(COMMUNITY_LIST_URL + '?' + new URLSearchParams({
    locationid: locationId,
    templateid: templateId,
  }), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(body),
  })
    .then(response => response.json())
    .then(response => {
      if (response.success != true) {
        console.error('API error occurred');
        return {};
      }
      return response;
    });
}

export const getCommunitiesNearYou = (longitude, latitude) => {
  return fetch(COMMUNITIES_NEAR_YOU_URL + new URLSearchParams({
    longitude,
    latitude,
  }))
    .then(response => response.json())
    .then(response => {
      return response;
    })
    .catch(console.error);
}

const testData = {
  "success": true,
  "amount": 14,
  "filters": [
    {
      "Title": "Bedroom",
      "FilterType": "Checkbox",
      "FilterColumn": "Bedroom",
      "Values": [
        {
          "Value": "Studio",
          "RawValue": "0",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "1 Bed",
          "RawValue": "1",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "2 Bed",
          "RawValue": "2",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "3 Bed",
          "RawValue": "3",
          "IsSelected": false,
          "Render": true
        }
      ]
    },
    {
      "Title": "Max Price",
      "FilterType": "RadioButton",
      "FilterColumn": "MaxPrice",
      "Values": [
        {
          "Value": "Up to $1350",
          "RawValue": "1350",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1430",
          "RawValue": "1430",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1510",
          "RawValue": "1510",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1590",
          "RawValue": "1590",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1670",
          "RawValue": "1670",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1750",
          "RawValue": "1750",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Up to $1830",
          "RawValue": "1830",
          "IsSelected": false,
          "Render": true
        }
      ]
    },
    {
      "Title": "Amenities",
      "FilterType": "Checkbox",
      "FilterColumn": "Amenities",
      "Values": [
        {
          "Value": "24/hr Fitness Center (6)",
          "RawValue": "24/hr Fitness Center",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Bark Park (5)",
          "RawValue": "Bark Park",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Cabana (2)",
          "RawValue": "Cabana",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Clubhouse (11)",
          "RawValue": "Clubhouse",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Concierge Service (1)",
          "RawValue": "Concierge Service",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Fitness Center (7)",
          "RawValue": "Fitness Center",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Garage Parking (4)",
          "RawValue": "Garage Parking",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Gated Community (1)",
          "RawValue": "Gated Community",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Grill & Picnic Area (13)",
          "RawValue": "Grill & Picnic Area",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "High Speed Internet (3)",
          "RawValue": "High Speed Internet",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "In unit Laundry (2)",
          "RawValue": "In unit Laundry",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "On-site Recycling (1)",
          "RawValue": "On-site Recycling",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Playground (7)",
          "RawValue": "Playground",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Pool (13)",
          "RawValue": "Pool",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Retail Access (2)",
          "RawValue": "Retail Access",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Running Trails (3)",
          "RawValue": "Running Trails",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Tennis (1)",
          "RawValue": "Tennis",
          "IsSelected": false,
          "Render": true
        }
      ]
    },
    {
      "Title": "Neighborhood",
      "FilterType": "Checkbox",
      "FilterColumn": "Neighborhood",
      "Values": [
        {
          "Value": "CITY",
          "RawValue": "city",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "LAKE",
          "RawValue": "lake",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "NONA",
          "RawValue": "nona",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "PARK",
          "RawValue": "park",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "CREEK",
          "RawValue": "creek",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "BURTON",
          "RawValue": "burton",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "BALDWIN",
          "RawValue": "baldwin",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "HUNTERS",
          "RawValue": "hunters",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "MEDICAL",
          "RawValue": "medical",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "ORLANDO",
          "RawValue": "orlando",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "DOWNTOWN",
          "RawValue": "downtown",
          "IsSelected": false,
          "Render": true
        }
      ]
    },
    {
      "Title": "Move-in",
      "FilterType": "RadioButton",
      "FilterColumn": "MoveIn",
      "Values": [
        {
          "Value": "Now",
          "RawValue": "now",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Within 2 weeks",
          "RawValue": "2weeks",
          "IsSelected": true,
          "Render": true
        },
        {
          "Value": "Within 1 month",
          "RawValue": "1month",
          "IsSelected": false,
          "Render": true
        },
        {
          "Value": "Within 2 months",
          "RawValue": "2months",
          "IsSelected": false,
          "Render": true
        }
      ]
    }
  ],
  "communities": [
    {
      "UniqueId": "sitecore://web/{1bcc85e5-a799-402c-98aa-494a25f36ca2}?lang=en&ver=26&ndx=sitecore_web_index",
      "CommunityId": "652922",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/assets/img/communities-preview.png",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "ec78261b-b360-4251-8646-e6842fd9cc92",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "No Rent Until June 1, 2023 on Select One Bedroom Units! Terms and Conditions apply.",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool deck at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-tiffany-oaks/slides/2021/2-tiffany-oaks-pool-deck.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "2a4f57d7-0a67-48d2-ac4c-480813ecea44",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Relax on the patio or take a dip in the pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Leasing office at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-tiffany-oaks/slides/2021/3-tiffany-oaks-leasing-office.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "b1152541-b915-417e-8a6f-8985f35eb108",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Enjoy the gorgeous, well-kept grounds",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Grilling area at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-tiffany-oaks/slides/2021/4-tiffany-oaks-grills.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "903c7394-19b0-4953-9984-eeb730784ab6",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Grill out with family and friends in the picnic area",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Clubhouse at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-tiffany-oaks/slides/2021/5-tiffany-oaks-clubhouse.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "28704f96-5210-4028-a988-c963bd7543d6",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "The clubhouse is the perfect spot for gatherings",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Clubhouse at MAA Tiffany Oaks luxury apartment homes in Orlando , FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-tiffany-oaks/slides/2021/6-tiffany-oaks-clubhouse-2.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "02f87d91-32ee-4f90-b8e1-dfeadb2d3a1d",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "A variety of spaces to suit your needs",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2
      ],
      "CommunityMinPrice": 1326,
      "CommunityMaxPrice": 3011,
      "CommunityNeighborhood": "null",
      "CommunityName": "MAA Tiffany Oaks",
      "CommunityCoordinate": {
        "Lat": 28.6563,
        "Lon": -81.3843
      },
      "CommunityAddress": "351 S Northlake Blvd.<br />Altamonte Springs, FL 32701",
      "CommunityPhoneNumber": "(407) 901-9289",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-tiffany-oaks/",
      "AddToCompareUrl": "/maa-api/compare/v1/652922",
      "IsSaved": true
    },
    {
      "UniqueId": "sitecore://web/{5553e6f5-e199-4bc3-86ea-d7b817b08515}?lang=en&ver=27&ndx=sitecore_web_index",
      "CommunityId": "652915",
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1388,
      "CommunityMaxPrice": 3743,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Twin Lakes",
      "CommunityCoordinate": {
        "Lat": 28.7926,
        "Lon": -81.3355
      },
      "CommunityAddress": "11500 Myrtlewood Drive<br />Sanford, FL 32771",
      "CommunityPhoneNumber": "(407) 305-7696",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-twin-lakes/",
      "AddToCompareUrl": "/maa-api/compare/v1/652915",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{8159e45a-79d9-4b7d-bb1c-c442a9241c89}?lang=en&ver=39&ndx=sitecore_web_index",
      "CommunityId": "1262882",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Exterior of MAA Robinson luxury apartments in Orlando, Florida",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/maa-robinson-exterior-twilight-no-banner-resized.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "19ef9cba-3add-41b3-b967-04f151365c2c",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Robinson!",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "MAA Robinson Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/mr-1.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "da601368-1ae3-4613-a8e0-c5640edbc481",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Beautiful rooftop pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Courtyard at MAA Robinson luxury apartments in Orlando, Florida",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/maa-robinson-courtyard.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "ddf16d1f-3057-4654-9f01-9a4ae7156553",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Gather with friends around the fire pits",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Courtyard at MAA Robinson luxury apartments in Orlando, Florida",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/maa-robinson-courtyard2.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "0e688d15-4ec6-4b7d-b86d-526f9a486248",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Amenities all around",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "MAA Robinson Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/mr-dog-park.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "812dbc72-8a58-4252-a416-c962c22ccdd7",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Endless amenities",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Common area at MAA Robinson luxury apartments in Orlando, Florida",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-robinson/maa-robinson-leasing.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "77924dd0-95dd-4a83-b1ea-2e6b97f97fdd",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Gorgeous common areas where you can meet and mingle",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        0,
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1463,
      "CommunityMaxPrice": 4733,
      "CommunityNeighborhood": "Downtown Orlando",
      "CommunityName": "MAA Robinson",
      "CommunityCoordinate": {
        "Lat": 28.54594,
        "Lon": -81.37955
      },
      "CommunityAddress": "310 N Orange Ave<br />Orlando, FL 32801",
      "CommunityPhoneNumber": "(407) 305-6926",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-robinson/",
      "AddToCompareUrl": "/maa-api/compare/v1/1262882",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{e5333a73-7429-45ff-941b-dcc40a90229b}?lang=en&ver=29&ndx=sitecore_web_index",
      "CommunityId": "728009",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "5a8254dc-9492-47f0-b232-962f235093cd",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Randal Lakes",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lake at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-lake.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "7a9eac67-dd41-4860-acf5-3075504baac9",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Take a walk around the peaceful lake",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness center at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-fitness-center.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "f44c58ed-2002-4242-a95d-884d3a80667b",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "A variety of equipment in the cardio fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness center at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-fitness-center2.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "97805c44-b930-46de-99bf-852d415904ab",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Focus on wellness in the fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Clubhouse at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-clubhouse.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "1f1fb330-ae3e-464d-a609-0893cd02e810",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "So many amenities to enjoy",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Business center at MAA Randal Lakes luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-randal-lakes/slides/2021/maa-randal-lakes-business-center.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "799c3647-4ac9-4865-b1d5-28d859561be3",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Tackle your to-do list in the business center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1528,
      "CommunityMaxPrice": 3948,
      "CommunityNeighborhood": "Lake Nona|Medical City",
      "CommunityName": "MAA Randal Lakes",
      "CommunityCoordinate": {
        "Lat": 28.4321,
        "Lon": -81.234
      },
      "CommunityAddress": "9200 Randal Park Blvd<br />Orlando, FL 32832",
      "CommunityPhoneNumber": "(407) 809-8438",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-randal-lakes/",
      "AddToCompareUrl": "/maa-api/compare/v1/728009",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{0cec8e1d-76db-4de9-a626-ed472dca7d0f}?lang=en&ver=19&ndx=sitecore_web_index",
      "CommunityId": "655017",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Aerial view at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/2020/tp-23.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "5988c9f1-abc7-41a1-a5ab-591795bd808b",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "For a limited time, $99 application fees with approved credit. Terms and conditions apply.",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Store 2 at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/22cgtownparkreserve_store2-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "1412b740-3f47-4764-839c-6c5d81ee7908",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Take a stroll through the shops",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Patio at MAA Town Park luxury apartment homes in Lake Mary, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park/slides/9-colonial-grand-at-town-park-lake-mary-fl_patio-3-2-1200x525.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "dd21aeb9-4da1-4e33-a6b2-54d2fe012595",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Relax on the patio",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/2020/tp5web-use.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "74094350-9e18-4663-8b49-4d8bad215149",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Sparkling pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/6cgtownpark_fitness-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "b0bc8e63-e2e1-472e-be3c-2bfabc6897f3",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lounge at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/5cgtownpark_lounge-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "5e3a504b-bc52-4282-ab0b-005c6bdb34c7",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Plenty of outdoor areas to relax",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2
      ],
      "CommunityMinPrice": 1623,
      "CommunityMaxPrice": 3763,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Town Park Reserve",
      "CommunityCoordinate": {
        "Lat": 28.79164,
        "Lon": -81.36055
      },
      "CommunityAddress": "1050 Colonial Grand Lane<br />Lake Mary, FL 32746",
      "CommunityPhoneNumber": "(407) 214-3762",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-town-park-reserve/",
      "AddToCompareUrl": "/maa-api/compare/v1/655017",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{bf57f39b-95af-46d4-bf70-7ef62e67deae}?lang=en&ver=23&ndx=sitecore_web_index",
      "CommunityId": "611807",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Aerial View MAA Parkside Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2021/mp-2.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "17b7b53a-3798-452a-8ec7-f3e70d79cfd7",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Parkside",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Aerial View MAA Parkside Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2021/mp-9.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "da1af279-b427-47ca-b42f-e0fe4c14f2dc",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Serene lake views await",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Exterior MAA Parkside Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2021/mp-28-(2).jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "c7418a22-3775-4ae8-9aef-e39fbfb02d7c",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Lush landscaping and lakeside walking paths",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool MAA Parkside Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2021/mp-4.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "649bec4a-bcf2-4c43-bf6d-817d3e1f7670",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Take a refreshing dip in the resort-style pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool 2 MAA Parkside Orlando Florida Apartments",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2021/mp-15.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "d266dd58-1d10-4341-a842-df6f5c71d94a",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Relax in the outdoor spaces",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Living Room with carpet at MAA Parkside Luxury Apartment Homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-parkside/slides/2022/3a4dininglivingcarpet.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "d3c59270-2094-4e26-ac35-f372898e945f",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Relax in comfortable living spaces",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        0,
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1630,
      "CommunityMaxPrice": 5400,
      "CommunityNeighborhood": "Downtown Orlando",
      "CommunityName": "MAA Parkside",
      "CommunityCoordinate": {
        "Lat": 28.5425,
        "Lon": -81.3718
      },
      "CommunityAddress": "431 E. Central Blvd Ste A<br />Orlando, FL 32801",
      "CommunityPhoneNumber": "(407) 214-5663",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-parkside/",
      "AddToCompareUrl": "/maa-api/compare/v1/611807",
      "IsSaved": true
    },
    {
      "UniqueId": "sitecore://web/{a89b139d-38fb-49d8-934c-74d668e00075}?lang=en&ver=23&ndx=sitecore_web_index",
      "CommunityId": "652903",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool Area at MAA Windermere in Orlando, FL ",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/1-pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "56768e35-6488-4390-bcb1-ccb77746138e",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Great specials ...call or visit us today!",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool Lounge at MAA Windermere in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/2-pool-lounge.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "bcc3180a-c9e7-41a5-a50f-5b57c8eff604",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Gather around in the outdoor pool lounge",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Clubhouse at MAA Windermere in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/3-clubhouse.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "af587670-4f52-4c83-9144-9eceb1c12a8d",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Stylish clubhouse",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lounge Area in MAA Windermere in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/4-lounge.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "db2f08e0-f65c-4928-98a0-d409c88d3aaf",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Visit with friends and family in the lounge",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Yoga Studio at MAA Windermere in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/5-yoga.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "8812af11-8700-4241-b7fd-02daf06f0792",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Reach your fitness goals in the yoga studio",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness Center at MAA Windermere in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-windermere/slides/2022/6-fitness.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "7175317f-efc0-41aa-9ab4-20277b66b963",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Work up a sweat in the fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1632,
      "CommunityMaxPrice": 4743,
      "CommunityNeighborhood": "Lake Burton",
      "CommunityName": "MAA Windermere",
      "CommunityCoordinate": {
        "Lat": 28.4505,
        "Lon": -81.5602
      },
      "CommunityAddress": "11598 Lachlan Lane<br />Windermere, FL 34786",
      "CommunityPhoneNumber": "(407) 988-0952",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-windermere/",
      "AddToCompareUrl": "/maa-api/compare/v1/652903",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{831f2c24-3cd3-4ed5-a9b4-260a32b28edc}?lang=en&ver=22&ndx=sitecore_web_index",
      "CommunityId": "652916",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Heathrow luxury apartment homes in Heathrow, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/cgh29web-use.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "8c626b02-a7d7-4421-9571-e40987a50853",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Reduced Rent on Select Apartment Homes! Terms and conditions may apply.",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "MAA Heathrow Luxury Apartments in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/maa-heathrow-3.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "19bef0e0-b171-4944-9244-2b5f1e415eab",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": null,
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Grilling Station at MAA Heathrow luxury apartment homes in Heathrow, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/2_colonial-grand-at-heathrow-pool-grill-1200x525.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "c76dd668-52da-4079-b049-cc3bb4d4d747",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Dine al fresco with poolside grilling stations",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Aerial 2 at MAA Heathrow luxury apartment homes in Heathrow, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/cgh6web-use.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "3a2017f4-2c84-4559-a29f-88a6bc1c4525",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Amenities for everyone",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Aerial at MAA Heathrow luxury apartment homes in Heathrow, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/cgh2web-use.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "0ab0a766-7ca6-494c-ac78-e11b82458784",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Beautiful views of Heathrow Golf Course",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Playground at MAA Heathrow luxury apartment homes in Heathrow, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heathrow/slides/cgh25web-use.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "6f9f1911-988f-413a-919f-63d12669c771",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Plenty of playground space for the kids to enjoy",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1683,
      "CommunityMaxPrice": 5003,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Heathrow",
      "CommunityCoordinate": {
        "Lat": 28.7729,
        "Lon": -81.3664
      },
      "CommunityAddress": "1122 Greenstone Boulevard<br />Heathrow, FL 32746",
      "CommunityPhoneNumber": "(407) 753-1497",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-heathrow/",
      "AddToCompareUrl": "/maa-api/compare/v1/652916",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{b4dc2d6a-26c6-4a0f-ae34-16fa03d26c16}?lang=en&ver=27&ndx=sitecore_web_index",
      "CommunityId": "652913",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/1_hg-pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "fdb6d320-7f24-48b1-b3c8-9904a2a12fd1",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Heather Glen",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/3_hg-grounds.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "b347c69b-f172-4344-b333-1905b64e200b",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Enjoy the beautiful scenery",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pond at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/4_hg-pond.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "4c4222b3-5603-4d12-a0d0-617bb2961a7d",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Lake and pond views just outside your door",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Playground at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/5_hg-playground.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "4cc14b2a-5114-4f9c-8bac-28b1e2c7be3c",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "There's something for everyone",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Clubhouse at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/6_hg-clubhouse.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "a5726f8b-86bb-40cf-b0ea-50f5f52c6956",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "The bright, spacious clubhouse is perfect for gathering with friends",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Business center at MAA Heather Glen luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-heather-glen/slides/7_hg-business-center.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "9b81936f-1974-422c-bcf5-63589899d1c3",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Tackle your to-do's in the business center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1693,
      "CommunityMaxPrice": 4913,
      "CommunityNeighborhood": "Hunters Creek",
      "CommunityName": "MAA Heather Glen",
      "CommunityCoordinate": {
        "Lat": 28.3702,
        "Lon": -81.4313
      },
      "CommunityAddress": "13184 Heather Moss Drive<br />Orlando, FL 32837",
      "CommunityPhoneNumber": "(407) 214-5811",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-heather-glen/",
      "AddToCompareUrl": "/maa-api/compare/v1/652913",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{d5a03abd-c522-4f39-b215-ca4dc2ef6cb2}?lang=en&ver=27&ndx=sitecore_web_index",
      "CommunityId": "652920",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Clubhouse Exterior at MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/1_ln-9_clubhouse-ext.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "3e839e87-0b63-4894-9836-a844710ffb43",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "For limited time, $99 application fees and waived processing fees with approved credit. Terms and conditions apply.",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Grounds at MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/2_ln-21_drone-view.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "34052f59-8bc1-4f0c-b898-d1eb6c60530c",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Lush green grounds with plenty of amenities",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/3_ln-1_drone-view-2.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "3e0fbf04-e316-475f-b077-3e7d9191c35a",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Serene lakeside views",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Building exterior at MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/4_ln-12_building-ext.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "05e86d40-8c22-486b-a53b-e88e847a8252",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Well-kept buildings and grounds",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool at MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/5_ln-14_pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "7adee3bb-f006-4a24-8f8f-e9a30e20118e",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Take a dip in the sparkling pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool deck at MAA Lake Nona luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-nona/slides/6_ln-4_pool-deck.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "acdfc7ac-dffa-4d00-b9d9-199ad1eff8c3",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Relax and unwind poolside",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1730,
      "CommunityMaxPrice": 5208,
      "CommunityNeighborhood": "Lake Nona|Medical City",
      "CommunityName": "MAA Lake Nona",
      "CommunityCoordinate": {
        "Lat": 28.4131,
        "Lon": -81.2389
      },
      "CommunityAddress": "10203 Falcon Parc Blvd<br />Orlando, FL 32832",
      "CommunityPhoneNumber": "(407) 449-7149",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-lake-nona/",
      "AddToCompareUrl": "/maa-api/compare/v1/652920",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{e00f3744-19f4-430f-acb4-054eb656109d}?lang=en&ver=25&ndx=sitecore_web_index",
      "CommunityId": "652914",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Exterior MAA Town Park luxury apartment homes in Lake Mary, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park/slides/2020/tp-1-edit.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "45fb965e-5c75-48f0-9903-bb1338702e07",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Town Park",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "MAA Town Park Luxury Apartments in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park/slides/2022/maa-town-park-1.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "4dc3e5f8-d852-4c42-9759-87d0a6149757",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": null,
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool at MAA Town Park luxury apartment homes in Lake Mary, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park/slides/2020/tp-5-edit.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "447f36a3-f61e-4c12-9b2a-a18e9458bbe5",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Beautifully landscaped grounds",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/6cgtownpark_fitness-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "b0bc8e63-e2e1-472e-be3c-2bfabc6897f3",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Yoga studio",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lounge at MAA Town Park Reserve luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park-reserve/slides/5cgtownpark_lounge-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "5e3a504b-bc52-4282-ab0b-005c6bdb34c7",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Serene outdoor areas ",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Tennis at MAA Town Park luxury apartment homes in Lake Mary, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-town-park/slides/2020/tp-7.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "c7257705-422c-48d5-bbf6-09997f1737a1",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Tennis court",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1748,
      "CommunityMaxPrice": 4153,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Town Park",
      "CommunityCoordinate": {
        "Lat": 28.79164,
        "Lon": -81.36055
      },
      "CommunityAddress": "1050 Colonial Grand Lane<br />Lake Mary, FL 32746",
      "CommunityPhoneNumber": "(407) 456-7930",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-town-park/",
      "AddToCompareUrl": "/maa-api/compare/v1/652914",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{878a0e6e-bca4-423d-b58e-b961fa674337}?lang=en&ver=27&ndx=sitecore_web_index",
      "CommunityId": "611810",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/1postlakeside_pool3-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "d1021a2a-b6c5-403c-b88f-4e9e8451e095",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "$1000 Off Select Two Bedroom Units and $99 Application Fee Special When You Look and Lease on the Same Day. Certain exclusions may apply.",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool 4 at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/1postlakeside_pool4-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "a9e4bd8f-0392-4773-9513-6b25fead4c5a",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Beautiful views",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Outdoor Seating at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/2postlakeside_outdoorseating-sand-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "9f45e726-1625-4cfa-925d-abd25f4cfd12",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Lounge in the sun",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Outdoor Seating at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/2postlakesideoutdoorseating2min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "040473ec-7525-4fb5-9bb1-c2405f6eca3b",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Comfortable outdoor seating",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Grill at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/3postlakeside_grill-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "8e88980d-219d-4c09-8a09-868b8b26efc1",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Grilling areas",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Exterior at MAA Crosswater luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-crosswater/slides/4postlakeside_exterior-min.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "e00a7c3e-b78a-4b8a-b702-a1b88edc23a2",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1760,
      "CommunityMaxPrice": 5180,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Crosswater",
      "CommunityCoordinate": {
        "Lat": 28.4483,
        "Lon": -81.562
      },
      "CommunityAddress": "7826 Crosswater Trail<br />Windermere, FL 34786",
      "CommunityPhoneNumber": "(407) 214-5799",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-crosswater/",
      "AddToCompareUrl": "/maa-api/compare/v1/611810",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{413fa171-b572-4cd9-a32a-06a330f071c7}?lang=en&ver=32&ndx=sitecore_web_index",
      "CommunityId": "611808",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Grounds at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/1-bp-grounds.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "19670c71-9c5e-4d0d-af7d-1268e5e45cf2",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Baldwin Park",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Pool at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/2-bp-pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "672b700c-a71a-49a9-8f8f-8bccd698c212",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Take in the gorgeous surroundings by the pool",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lake view terrace at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/3-bp-lake-view.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "e5157498-bf05-4d91-b099-f0ee1a081033",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Enjoy lake views on the terrace",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Lakeside fountain at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/4-bp-fountain.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "3309d3b4-a0d9-4115-a85b-ef8983d56331",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Catch the sunset by the bubbling fountain",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness center at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/5-bp-fitness.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "2d71259c-f1e3-4480-99bd-411d32e11e1f",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Reach your goals in the fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Yoga and TRX studio at MAA Baldwin Park luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-baldwin-park/slides/2021/6-bp-fitness-studio.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "70301ccf-cc1a-4c5d-96e3-7902693c465a",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Make wellness a priority in the yoga and TRX studio",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1779,
      "CommunityMaxPrice": 4645,
      "CommunityNeighborhood": "Baldwin Park",
      "CommunityName": "MAA Baldwin Park",
      "CommunityCoordinate": {
        "Lat": 28.5646,
        "Lon": -81.3292
      },
      "CommunityAddress": "4688 New Broad Street<br />Orlando, FL 32814",
      "CommunityPhoneNumber": "(866) 282-6645",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-baldwin-park/",
      "AddToCompareUrl": "/maa-api/compare/v1/611808",
      "IsSaved": false
    },
    {
      "UniqueId": "sitecore://web/{de10bfd4-ec18-4680-b2fa-96d9a2cd20ea}?lang=en&ver=29&ndx=sitecore_web_index",
      "CommunityId": "652917",
      "CommunityImages": [
        {
          "Image": {
            "Alt": "Pool at MAA Lake Mary luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/1_lm-7_pool.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "1e91d83c-24ed-43af-ab12-d97294d28aed",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Welcome home to MAA Lake Mary",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Signage at MAA Lake Mary luxury apartment homes in Lake Mary, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/signage-2022/maa-lake-mary.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "3fcd481b-1adb-4650-b853-abc199217992",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Visit us in the beautiful leasing office",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Business center at MAA Lake Mary luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/4_lm-17_business-center.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "569d2b68-449c-4104-b5e2-29acd89c1a18",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Well-equipped business center to help your productivity",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Fitness center at MAA Lake Mary luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/5_lm-20_fitness.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "1d351f01-a17e-4ee0-8485-3b768fbd9217",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Focus on wellness in the fitness center",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Kitchen at MAA Lake Mary luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/6_lm-14_kitchen.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "7676479f-ba9a-4081-a021-386f40f57c93",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Spacious kitchens with room to entertain",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        },
        {
          "Image": {
            "Alt": "Living room at MAA Lake Mary luxury apartment homes in Orlando, FL",
            "Border": null,
            "Class": null,
            "Height": 0,
            "HSpace": 0,
            "Src": "/-/media/images/properties/florida/orlando/maa-lake-mary/slides/7_lm-23_living.jpg",
            "VSpace": 0,
            "Width": 0,
            "MediaId": "34ecbd0f-3bba-4d64-9bf3-6802de62b921",
            "Title": null,
            "Language": null,
            "MediaExists": false
          },
          "Description": "Open spaces with natural light",
          "Id": "00000000-0000-0000-0000-000000000000",
          "Version": 0,
          "Language": null,
          "Name": null,
          "ContentPath": null,
          "FullPath": null,
          "Url": null,
          "DisplayName": null,
          "TemplateName": null,
          "TemplateId": "00000000-0000-0000-0000-000000000000",
          "RendererId": null
        }
      ],
      "CommunityUnitTypes": [
        1,
        2,
        3
      ],
      "CommunityMinPrice": 1783,
      "CommunityMaxPrice": 4153,
      "CommunityNeighborhood": "",
      "CommunityName": "MAA Lake Mary",
      "CommunityCoordinate": {
        "Lat": 28.7818,
        "Lon": -81.3597
      },
      "CommunityAddress": "225 Sunlight Lane<br />Lake Mary, FL 32746",
      "CommunityPhoneNumber": "(407) 759-7524",
      "CommunitySpecial": null,
      "CommunityPageUrl": "/florida/orlando/maa-lake-mary/",
      "AddToCompareUrl": "/maa-api/compare/v1/652917",
      "IsSaved": false
    }
  ]
}



// WEBPACK FOOTER //
// ./src/js/api/community.js